import React from "react";
import { Button } from "@magicbi/ui-library";
import { InfoDialog } from "../../molecules/InfoDialog";
import { ListConfirmDialog } from "../../molecules/ListConfirmDialog";
import { modelReviewCopy as copy } from "../../../services/modelling/modelStatus.copy";
import type { ModelReviewDialogProps } from "./ModelReviewDialog.types";
import { useModelReviewDialogState } from "./useModelReviewDialogState";

/** The tenant admin's review of a held data-model update: what it adds, changes and retires, then Approve or Reject. */
export const ModelReviewDialog: React.FC<ModelReviewDialogProps> = ({ runId, onClose }) => {
  const view = useModelReviewDialogState(runId, onClose);
  return (
    <>
      <InfoDialog
        isOpen={view.isOpen}
        title={copy.title}
        titleId="model-review-title"
        onClose={view.onClose}
        sections={view.sections}
        action={
          <>
            <Button variant="danger-outline" onClick={view.onReject} disabled={view.actionsDisabled}>
              {copy.reject}
            </Button>
            <Button variant="primary-dark" onClick={view.onApprove} disabled={view.actionsDisabled} loading={view.approving}>
              {copy.approve}
            </Button>
          </>
        }
      />
      <ListConfirmDialog {...view.confirm} />
    </>
  );
};

export default ModelReviewDialog;
